import { Injectable } from '@angular/core';
import { appVersion } from '../appVersion.js';
import { AppSetupDb } from 'lib/cosmos/app-setup/appSetupDb.js';

export interface IAppVersionState {
	isOutdated: boolean;
	newVersion: string;
	currentVersion: string;
}

@Injectable({
	providedIn: 'root'
})
export class AppVersionService {

	getAppVersionState(appSetup: AppSetupDb.IAppSetupItem): IAppVersionState {
		const currentVersion = appVersion.version.toLowerCase().trim();
		const newVersion = appSetup.appVersion.toLowerCase().trim();

		const result: IAppVersionState = {
			isOutdated: currentVersion !== newVersion,
			currentVersion: currentVersion,
			newVersion: newVersion
		};

		return result;
	}
}
